<template>
  <div id="app">
    <keep-alive>
      <component v-bind:is="currentView" @viewChanged="currentView = $event"></component>
    </keep-alive>
    <app-dialog></app-dialog>
    <app-loading></app-loading>
    <app-snackbar></app-snackbar>
    <app-toast></app-toast>
  </div>
</template>

<script>
import Dialog from './components/Shared/Dialog/'
import Home from './components/Shared/Home/'
import Loading from './components/Shared/Loading/'
import Login from './components/Shared/Login/'
import Snackbar from './components/Shared/Snackbar/'
import Toast from './components/Shared/Toast/'

export default {
  data: function() {
    return {
      currentView: Login,
      showLoading: false,
      snackbar: {}
    }
  },
  methods: {
    checkSession () {
      // setTimeout( () => {
      //   axios.get(this.api + 'login/?user=')
      //     .then( response => {
      //       console.log(response)
      //     }).catch( error => {

      //     })
      // }, 1000)
    },
    reloadToken () {
      const self = this

      /*gapi.load('auth2', function() {
        gapi.auth2.init().then(googleAuth => {
          const googleUser = googleAuth.currentUser.get(),
                authResponse = googleUser.getAuthResponse(),
                idToken = authResponse.id_token
                // isNewToken = self.$user.data.idToken !== idToken

          // if (isNewToken) {
            self.$user.data.idToken = idToken
            self.$http.defaults.headers.common['Authorization'] = idToken
            return self.$idb.keyVal.set('login', undefined, self.$user.data)
          // }
        })
      })*/
    }
  },
  mounted() {
    const self = this,
          toast = this.$toast

    this.$http.interceptors.response.use(response => {
      const status = response.data.status ? response.data.status : false
      if (status && status.match(/no\sautorizado/)) {
        // self.reloadToken()
        return toast.show('Por favor, intenta de nuevo realizar la consulta.')
      }

      if (response.data.success === '0') {
        return toast.show(response.data.response)
      }

      return response
    }, error => {
      const errorData = error.response ? error.response.data : false
      if (errorData && errorData.status.match(/no\sautorizado/)) {

        // self.reloadToken()
        return toast.show('Por favor, intenta de nuevo realizar la consulta.')
      }
    })
  },
  components: {
    Login,
    Home,
    'app-dialog': Dialog,
    'app-loading': Loading,
    'app-snackbar': Snackbar,
    'app-toast': Toast
  }
}
</script>

<style src="./styles/global.scss" lang="scss"></style>


// WEBPACK FOOTER //
// App.vue?21e68a7c